module.exports = __webpack_public_path__ + "static/media/kixlab.768fe0be.png";